export default __webpack_public_path__ + "static/media/ben-duchac.ca318a54.jpg";